import {
  Box,
  Button,
  Chip,
  CircularProgress,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@material-ui/core";
import {
  ChevronLeft,
  ChevronRight,
  EditOutlined,
  InfoOutlined,
  KeyboardArrowDown,
  KeyboardArrowUp,
  PeopleOutline,
  PersonOutline,
} from "@material-ui/icons";
import {
  Background,
  Controls,
  Handle,
  MarkerType,
  ReactFlow,
  useEdgesState,
  useNodesState
} from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import { motion } from "framer-motion";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomAddModal from "../../../components/Common/CustomAddModal";
import CustomShowModal from "../../../components/Common/CustomShowModal";
import AddNewUserFromNodes from "../../../components/Dashboard/AddNewUserFromNodes";
import * as dashboardActions from "../../../containers/User/Dashboard/actions";
import {
  getCurrentUserId,
  getObject,
  getOrganizationId,
  setOrganizationId as setOrgId,
  toastError,
  toastSuccess,
} from "../../../utils";
import AddUserForm from "./AddUserForm";

const inititalUser = {
  dateOfBirth: "",
  email: "",
  firstName: "",
  lastName: "",
  organizationId: "",
  password: "",
  role: "user",
  isPremium: false,
  isVerified: false,
  premiumAccessExpiry: "",
  isPaid: false,
  request: {},
  moduleAccess: [],
  moduleHeads: {},
};

export const CustomNode = ({ data }) => {
  return (
    <div className="custom-node">
      <Handle type="source" position="bottom" id="a" />
      {data.label}
      <Handle type="target" position="top" id="b" />
    </div>
  );
};

const nodeTypes = {
  custom: CustomNode,
};

const UserList = ({
  isSelection = false,
  onSelectionChange = () => { },
  selectedUsers = [],
  setSelectedUsers = () => { },
}) => {
  const reactFlowInstanceRef = useRef(null);
  const { userOrganizaton = [] } = useSelector((state) => state.dashboard);
  const [isModalOpen, setModalOpen] = useState(false);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(true);
  const [openCreateOrgModal, setOpenCreateOrgModal] = useState(false);
  const orgId = getOrganizationId();
  const [organizationId, setOrganizationId] = useState(orgId);
  const [expandedRows, setExpandedRows] = useState({});
  const [newOrganization, setNewOrganization] = useState({
    organizationName: "",
    organizationAdmin: getCurrentUserId(),
  });
  const isSuperBoss = getObject("auth")?.role === "superboss";
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(isSelection ? 5 : 10);
  const [totalPages, setTotalPages] = useState(0);
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const [parentUser, setParentUser] = useState({});
  const [newUser, setNewUser] = useState(inititalUser);
  const [isUserCreateModalOpen, setIsUserCreateModalOpen] = useState(false);
  const [isSuperAdminLogin, setIsSuperAdminLogin] = useState(false);

  const [initialEditData, setInitialEditData] = useState(null);
  const [isRequestInfoModalOpen, setIsRequestInfoModalOpen] = useState(false);
  const [requestDataFromLocal, setRequestDataFromLocal] = useState(null);
  const [expandedHeadId, setExpandedHeadId] = useState(null);
  const [hasAutoExpanded, setHasAutoExpanded] = useState(false); // Add this line
  const [selectionSearch, setSelectionSearch] = useState("");
  const allAccess = [
    { id: 1, name: "Premium", value: "isPremium" },
    { id: 2, name: "Verified", value: "isVerified" },
  ];

  useEffect(() => {
    let auth = getObject("auth");
    if (auth?.isLoginBySuperAdmin === true) {
      setIsSuperAdminLogin(true);
    }
  }, []);

  useEffect(() => {
    if (!loader && userOrganizaton.length > 0 && !hasAutoExpanded) {
      const timer = setTimeout(() => {
        const firstHead = userOrganizaton.find((user) => user.role === "head");

        if (firstHead) {
          setExpandedHeadId(firstHead._id);
        }
        setHasAutoExpanded(true);

      }, 500);
      return () => clearTimeout(timer);
    }
  }, [userOrganizaton, loader, hasAutoExpanded]);

  const [hasFetched, setHasFetched] = useState(false);
  const [isInitialLoading, setIsInitialLoading] = useState(true);

  const fetchUserOrganization = () => {
    if (organizationId) {
      if (!hasFetched && (!userOrganizaton || userOrganizaton.length === 0)) {
        setIsInitialLoading(true);
      }
      dispatch(
        dashboardActions.usersForOrg({
          organizationId,
          getTeamUser: isSelection,
          limit: 100,
        }),
      )
        .then(() => {
          setIsInitialLoading(false);
          setHasFetched(true);
          setLoader(false);
        })
        .catch(() => {
          setIsInitialLoading(false);
          setHasFetched(true);
          setLoader(false);
        });
    } else {
      setIsInitialLoading(false);
      setHasFetched(true);
      setLoader(false);
    }
  };
  useEffect(() => {
    fetchUserOrganization();
  }, [organizationId]);

  useEffect(() => {
    const filteredUsers = isSelection
      ? userOrganizaton.filter(
        (user) => user.role === "head" || user.role === "superboss",
      )
      : userOrganizaton;
    setTotalPages(Math.ceil(filteredUsers.length / rowsPerPage));
  }, [userOrganizaton, rowsPerPage, isSelection]);

  const handleSelectUser = (userId, userName) => {
    setSelectedUsers(() => {
      const newSelection = [{ id: userId, name: userName }];

      if (onSelectionChange) {
        onSelectionChange(newSelection);
      }

      return newSelection;
    });
  };

  const isSelected = (userId) => {
    return selectedUsers.some((user) => user.id === userId);
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const getFilteredUsers = () => {
    if (!isSelection) {
      return userOrganizaton;
    } else {
      return userOrganizaton.filter(
        (user) => user.role === "head" || user.role === "superboss",
      );
    }
  };

  const getCurrentPageData = () => {
    const filteredUsers = getFilteredUsers();
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return filteredUsers.slice(startIndex, endIndex);
  };

  const handleCreateOrg = () => {
    setOpenCreateOrgModal(true);
  };

  const handleCloseModal = () => {
    setOpenCreateOrgModal(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewOrganization((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitOrganization = async () => {
    try {
      const response =
        await dashboardActions.createOrganization(newOrganization);
      if (response) {
        setNewOrganization({
          organizationName: "",
        });
        setOrganizationId(response?.data?._id);
        setOrgId(response?.data?._id);
        await dashboardActions.assignUserToOrganization({
          userId: getCurrentUserId(),
          organizationId: response?.data?._id,
        });
        dispatch(
          dashboardActions.usersForOrg({ organizationId: response?.data?._id }),
        );
        handleCloseModal();
        toastSuccess("Organization created successfully!");
      }
    } catch (error) {
      toastError(error?.data?.message || "Failed to create organization!");
    }
  };

  const toggleRowExpand = (userId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [userId]: !prev[userId],
    }));
  };


  const getCenteredX = (index, total, spacing) =>
    (index - (total - 1) / 2) * spacing;

  const determineUserRole = (user) => user.role;

  const getUsersUnderHead = (headId, allUsers) => {
    const usersUnderHead = [];
    const addedUserIds = new Set();

    allUsers.forEach((user) => {
      if (user.role !== "user" || !user.moduleHeads) return;

      if (addedUserIds.has(user._id)) return;

      for (const [module, heads] of Object.entries(user.moduleHeads)) {
        if (heads.some((head) => head._id === headId)) {
          usersUnderHead.push({
            ...user,
            uniqueId: `${user._id}-${headId}`,
            reportingModule: module,
            reportingHeadId: headId,
          });
          addedUserIds.add(user._id);
          break;
        }
      }
    });

    return usersUnderHead;
  };

  const handleHeadClick = (headId) => {
    setExpandedHeadId((prev) => (prev === headId ? null : headId));
  };

  useEffect(() => {
    const data = getFilteredUsers();

    const categorizedUsers = {
      superboss: [],
      head: [],
      user: [],
    };

    data.forEach((user) => {
      const role = determineUserRole(user);
      if (categorizedUsers[role]) {
        categorizedUsers[role].push(user);
      }
    });

    const currentViewport = reactFlowInstanceRef.current?.getViewport();

    const currentPositions = {};
    nodes.forEach((node) => {
      currentPositions[node.id] = node.position;
    });

    const newNodes = [];
    const newEdges = [];
    const verticalSpacing = 450;
    const horizontalSpacing = 400;

    const NODE_WIDTH = 250;
    const NODE_HEIGHT = 100;
    const MARGIN = 40;

    const occupiedRects = [];

    const isOverlapping = (x, y) => {
      return occupiedRects.some((rect) => {
        return (
          x < rect.x + rect.width + MARGIN &&
          x + NODE_WIDTH + MARGIN > rect.x &&
          y < rect.y + rect.height + MARGIN &&
          y + NODE_HEIGHT + MARGIN > rect.y
        );
      });
    };

    const getSafePosition = (x, y) => {
      let safeX = x;
      let attempts = 0;
      while (isOverlapping(safeX, y) && attempts < 100) {
        safeX += horizontalSpacing;
        attempts++;
      }

      occupiedRects.push({
        x: safeX,
        y,
        width: NODE_WIDTH,
        height: NODE_HEIGHT,
      });
      return { x: safeX, y };
    };

    const levelPositions = {
      superboss: 20,
      head: 20 + verticalSpacing,
    };

    if (categorizedUsers.superboss.length > 0) {
      categorizedUsers.superboss.forEach((user, index) => {
        const nodeId = user.uniqueId || user._id;
        const roughPos = currentPositions[nodeId] || {
          x: getCenteredX(
            index,
            categorizedUsers.superboss.length,
            horizontalSpacing,
          ),
          y: levelPositions.superboss,
        };

        const position = getSafePosition(roughPos.x, roughPos.y);

        newNodes.push(
          createUserNode(user, position, true, "superboss", () =>
            handleHeadClick(user._id),
          ),
        );
      });
    }

    if (categorizedUsers.head.length > 0) {
      categorizedUsers.head.forEach((user, index) => {
        const nodeId = user.uniqueId || user._id;
        const roughPos = currentPositions[nodeId] || {
          x: getCenteredX(
            index,
            categorizedUsers.head.length,
            horizontalSpacing,
          ),
          y: levelPositions.head,
        };

        const position = getSafePosition(roughPos.x, roughPos.y);

        newNodes.push(
          createUserNode(user, position, true, "head", () =>
            handleHeadClick(user._id),
          ),
        );
      });
    }

    if (expandedHeadId) {
      const usersUnderExpandedHead = getUsersUnderHead(expandedHeadId, data);
      const parentNode =
        newNodes.find((n) => n.id === expandedHeadId) ||
        nodes.find((n) => n.id === expandedHeadId);

      const parentX = parentNode?.position?.x || 0;
      const parentY = parentNode?.position?.y || 0;

      const userLevelY = parentY + verticalSpacing;

      usersUnderExpandedHead.forEach((user, index) => {
        const nodeId = user.uniqueId || user._id;

        const baseX =
          parentX +
          index * horizontalSpacing -
          ((usersUnderExpandedHead.length - 1) * horizontalSpacing) / 2;

        const position = getSafePosition(baseX, userLevelY);

        newNodes.push(
          createUserNode(user, position, false, "user", undefined, {
            x: parentX,
            y: parentY,
          }),
        );

        newEdges.push(
          createEdge(user.reportingHeadId, user.uniqueId, "#10b981", index),
        );
      });
    }

    if (
      categorizedUsers.superboss.length > 0 &&
      categorizedUsers.head.length > 0
    ) {
      const superboss = categorizedUsers.superboss[0];
      categorizedUsers.head.forEach((head, index) => {
        newEdges.push(createEdge(superboss._id, head._id, "#8b5cf6", index));
      });
    }

    setNodes(newNodes);
    setEdges(newEdges);

    if (currentViewport && reactFlowInstanceRef.current) {
      setTimeout(() => {
        reactFlowInstanceRef.current?.setViewport(currentViewport);
      }, 0);
    }
  }, [userOrganizaton, page, rowsPerPage, expandedHeadId]);

  const onInit = (reactFlowInstance) => {
    reactFlowInstanceRef.current = reactFlowInstance;
  };

  const createUserNode = (
    user,
    position,
    isClickableHead = false,
    role = "user",
    onClick,
    animateFrom = null,
  ) => {
    const nodeId = user.uniqueId || user._id;
    const showExpandIndicator =
      (role === "head" || role === "superboss") &&
      getUsersUnderHead(user._id, getFilteredUsers()).length > 0;

    let initial = {
      opacity: 0,
      scale: 0.9,
      y: 300,
      transformOrigin: "top center",
    };

    if (animateFrom) {
      initial = {
        opacity: 0,
        scale: 0.5,
        x: animateFrom.x - position.x,
        y: animateFrom.y - position.y,
        transformOrigin: "center center",
      };
    }
    return {
      id: nodeId,
      position,
      data: {
        label: (
          <motion.div
            className={`
            relative p-5 rounded-xl shadow-sm border border-gray-200
            w-72 backdrop-blur-sm transition-all duration-200
            ${getRoleBorderRing(role)}
            bg-white
              ${isClickableHead
                ? `cursor-pointer hover:shadow-md hover:${getActiveCardBorderRing(
                  role,
                )} hover:-translate-y-0.5`
                : ""
              }
              ${expandedHeadId === user._id ? getActiveCardBorderRing(role) : ""
              }
          `}
            onClick={isClickableHead ? onClick : undefined}
            initial={initial}
            animate={{
              opacity: 1,
              scale: 1,
              x: 0,
              y: 0,
              transition: {
                duration: 0.3,
                ease: "easeOut",
              },
            }}
            exit={{
              opacity: 0,
              scale: 0.8,
              y: 300,
              transition: {
                duration: 0.2,
                ease: "easeIn",
              },
            }}
            layout
          >
            <div className="flex items-start gap-3 mb-3">
              <div
                className={`w-10 h-10 rounded-full ${getRoleBgColor(
                  role,
                )} ${getRoleTextColor(role)} ${getRoleBorderRing(
                  role,
                )} flex items-center justify-center font-semibold text-sm shrink-0 shadow-sm`}
              >
                {user?.profileImage ? (
                  <img
                    src={user?.profileImage}
                    alt={user?.firstName}
                    className="w-10 h-10 rounded-full"
                  />
                ) : (
                  <span>
                    {user?.firstName?.[0]}
                    {user?.lastName?.[0]}
                  </span>
                )}
              </div>
              <div className="ml-auto mt-1 flex items-center gap-1">
                <span
                  className={`text-xs font-medium transition-colors ${user.isActivated ? "text-emerald-600" : "text-rose-600"
                    }`}
                >
                  {user.isActivated ? "Active" : "Inactive"}
                </span>
                <div
                  className={`w-2.5 h-2.5 rounded-full transition-colors ${user.isActivated ? "bg-emerald-500" : "bg-rose-500"
                    }`}
                />
              </div>
            </div>

            <div className="space-y-6">
              <div>
                <div className="text-gray-900 text-xl font-semibold leading-tight">
                  {user?.firstName} {user?.lastName}
                </div>
                <div
                  className="text-gray-600 text-sm font-medium truncate mt-1"
                  title={user?.email}
                >
                  {user.email}
                </div>
              </div>

              <div className="flex items-center justify-between mt-5">
                <span
                  className={`inline-flex items-center px-2.5 capitalize py-1 rounded-full text-sm font-medium border ${getRoleBorderRing(
                    role,
                  )} ${getRoleTextColor(role)} shadow-sm`}
                >
                  {role}
                </span>
              </div>

              <div className="ml-auto flex justify-between items-center gap-2">
                {showExpandIndicator && (
                  <div className="flex items-center text-xs text-gray-500 hover:text-gray-600 cursor-pointer transition group">
                    <span
                      className={`mr-1 ${expandedHeadId === user._id
                        ? "underline text-gray-700"
                        : ""
                        }`}
                    >
                      Expand
                    </span>
                    <svg
                      className={`transform ${expandedHeadId === user._id ? "rotate-180" : ""
                        } transition duration-300`}
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </div>
                )}
                {isSuperAdminLogin &&
                  (user.role === "superboss" || user.role === "head") && (
                    <div>
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleCreateUserClick(user);
                        }}
                        className="text-xs border border-sky-600 rounded-full px-2 py-1 ring-2 ring-sky-600 text-sky-600 hover:underline font-medium transition"
                      >
                        + Create User
                      </button>
                    </div>
                  )}
              </div>
            </div>

            {Object.entries(user.moduleHeads || {}).length > 0 &&
              user.role === "user" && (
                <div className="pt-2 border-t border-gray-500 mt-2">
                  <div className="text-xs text-gray-500 mb-1">
                    Module Access
                  </div>
                  <div className="flex flex-wrap gap-3">
                    {Object.entries(user.moduleHeads).map(([module, heads]) => {
                      const filteredHeads = heads.filter(
                        (head) => head._id === expandedHeadId,
                      );
                      return filteredHeads.length > 0 ? (
                        <span
                          key={module}
                          className={`inline-flex items-center px-2 py-1 rounded-md text-xs font-medium border ${getRoleBorderRing(
                            role,
                          )} ${getRoleTextColor(role)} ${getRoleBgColor(
                            role,
                          )} shadow-sm`}
                        >
                          {module}
                        </span>
                      ) : null;
                    })}
                  </div>
                </div>
              )}

            {user?.moduleAccess?.length > 0 && user.role === "head" && (
              <div className="pt-2 border-t border-gray-500 mt-2">
                <div className="text-xs text-gray-500 mb-1">Module Access</div>
                <div className="flex flex-wrap gap-3">
                  {user.moduleAccess.map((module) => {
                    return (
                      <span
                        key={module}
                        className={`inline-flex items-center px-2 py-1 rounded-md text-xs font-medium border ${getRoleBorderRing(
                          role,
                        )} ${getRoleTextColor(role)} ${getRoleBgColor(
                          role,
                        )} shadow-sm`}
                      >
                        {module}
                      </span>
                    );
                  })}
                </div>
              </div>
            )}

            <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-gray-200 to-transparent rounded-t-xl" />
          </motion.div>
        ),
      },
      style: {
        width: "fit-content",
        shadow: "none",
        background: "transparent",
        border: "none",
        padding: 0,
      },
      type: "custom",
    };
  };

  const createEdge = (source, target, color = "#4f46e5", index = 0) => ({
    id: `edge-${source}-${target}-${index}`,
    source,
    target,
    type: "smoothstep",
    animated: true,
    style: {
      stroke: color,
      strokeWidth: 2,
    },
    markerEnd: {
      type: MarkerType.ArrowClosed,
      width: 12,
      height: 12,
      color: color,
    },
    className: "animated-edge",
  });

  const getRoleBgColor = (role) => {
    switch (role) {
      case "superboss":
        return "bg-rose-100";
      case "head":
        return "bg-sky-100";
      case "user":
        return "bg-emerald-100";
      default:
        return "bg-gray-100";
    }
  };

  const getRoleTextColor = (role) => {
    switch (role) {
      case "superboss":
        return "text-rose-700";
      case "head":
        return "text-sky-700";
      case "user":
        return "text-emerald-700";
      default:
        return "text-gray-600";
    }
  };

  const getRoleBorderRing = (role) => {
    switch (role) {
      case "superboss":
        return "border-rose-500 ring-2 ring-rose-200";
      case "head":
        return "border-sky-500 ring-2 ring-sky-200";
      case "user":
        return "border-emerald-500 ring-2 ring-emerald-200";
      default:
        return "border-gray-300 ring-1 ring-gray-200";
    }
  };

  const getActiveCardBorderRing = (role) => {
    switch (role) {
      case "superboss":
        return "border-2 border-rose-500 ring-1 ring-rose-200";
      case "head":
        return "border-2 border-sky-500 ring-1 ring-sky-200";
      case "user":
        return "border-2 border-emerald-500 ring-1 ring-emerald-200";
      default:
        return "border-2 border-gray-300 ring-1 ring-gray-200";
    }
  };

  const handleCreateUserClick = (parentUser) => {
    setParentUser(parentUser);
    setIsUserCreateModalOpen(true);
    setNewUser({
      ...inititalUser,
      organizationId: parentUser.organizationId,
    });
  };

  const onSubmitConfirm = () => {
    let payload = {
      ...newUser,
      dateOfBirth: moment(newUser.dateOfBirth).format(),
      isFromDiagram: true,
    };
    dashboardActions
      .createUser(payload)
      .then(() => {
        toastSuccess("User Created Successfully");
        setExpandedHeadId(parentUser._id);
        setParentUser({});
        setIsUserCreateModalOpen(false);
        fetchUserOrganization();
      })
      .catch((err) => {
        toastError(err?.data?.message);
      });
  };

  if (!organizationId) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="Calc(100vh - 102px)"
        textAlign="center"
      >
        <Typography variant="h6" gutterBottom>
          You don't have an organization yet
        </Typography>
        <Typography variant="body1" gutterBottom>
          Create an organization to get started
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleCreateOrg}
          style={{ marginTop: 20 }}
        >
          Create Organization
        </Button>
        <CustomShowModal
          open={openCreateOrgModal}
          handleClose={handleCloseModal}
          maxWidth="sm"
          title="Create New Organization"
        >
          <div className="flex flex-col gap-6 p-4">
            <div className="relative overflow-hidden rounded-lg border border-[#C7D2FE] bg-[#EEF2FF] p-4">
              <div className="flex items-start gap-3">
                <div className="shrink-0 mt-0.5">
                  <svg
                    className="h-5 w-5 text-[#4F46E5]"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M2.25 21h19.5m-18-18v18m10.5-18v18m6-13.5V21M6.75 6.75h.75m-.75 3h.75m-.75 3h.75m3-6h.75m-.75 3h.75m-.75 3h.75M6.75 21v-3.375c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21M3 3h12m-.75 4.5H21m-3.75 3.75h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008zm0 3h.008v.008h-.008v-.008z"
                    />
                  </svg>
                </div>

                <div>
                  <h3 className="text-sm font-semibold text-[#312E81]">
                    Establish Your Team Workspace
                  </h3>
                  <p className="mt-1 text-sm text-[#4338CA] leading-relaxed">
                    Create an organization to manage your team members, share
                    contracts, collaborate on voyage estimations, and more in
                    one central place.
                  </p>

                  <div className="mt-3 flex items-center gap-2 rounded-md bg-white/60 p-2 border border-[#C7D2FE]">
                    <svg
                      className="h-4 w-4 text-[#4F46E5]"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <span className="text-xs font-medium text-[#312E81]">
                      Note: For extra users, you need to contact support.
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <label
                htmlFor="organizationName"
                className="block text-sm font-medium text-[#374151] mb-1.5"
              >
                Organization Name <span className="text-[#EF4444]">*</span>
              </label>

              <div className="relative">
                <input
                  type="text"
                  id="organizationName"
                  name="organizationName"
                  value={newOrganization.organizationName}
                  onChange={handleInputChange}
                  placeholder="e.g., Global Shipping Logistics Ltd."
                  className="block w-full rounded-md border border-[#D1D5DB] px-3 py-2.5 text-[#111827] shadow-sm placeholder:text-[#9CA3AF] focus:border-[#4F46E5] focus:ring-1 focus:ring-[#4F46E5] sm:text-sm transition-colors duration-200 ease-in-out"
                  required
                  autoFocus
                />
              </div>
              <p className="mt-2 text-xs text-[#6B7280]">
                This will be the displayed name for all your team's shared
                assets.
              </p>
            </div>

            <div className="flex justify-end gap-3 pt-2 border-t border-gray-100 mt-2">
              <button
                onClick={handleCloseModal}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#4F46E5] transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleSubmitOrganization}
                disabled={!newOrganization.organizationName}
                className="px-4 py-2 text-sm font-medium text-white bg-[#4F46E5] border border-transparent rounded-md shadow-sm hover:bg-[#4338CA] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#4F46E5] disabled:opacity-50 disabled:cursor-not-allowed transition-all"
              >
                Create Organization
              </button>
            </div>
          </div>
        </CustomShowModal>
      </Box>
    );
  }

  if (organizationId && !isInitialLoading && userOrganizaton.length === 0) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        height="300px"
        textAlign="center"
      >
        <Typography variant="h6" gutterBottom>
          No users in your organization yet
        </Typography>
        <Typography variant="body1" gutterBottom>
          Invite users to join your organization
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setModalOpen(true)}
          style={{ marginTop: 20 }}
        >
          Invite Users
        </Button>
      </Box>
    );
  }

  if (isSelection) {
    const term = selectionSearch.trim().toLowerCase();
    const matches = (u) =>
      !term ||
      `${u.firstName || ""} ${u.lastName || ""} ${u.email || ""}`
        .toLowerCase()
        .includes(term);
    const heads = getFilteredUsers().filter(
      (u) => matches(u) || (u.team_members || []).some(matches),
    );
    const pageCount = Math.max(1, Math.ceil(heads.length / rowsPerPage));
    const currentPage = Math.min(page, pageCount - 1);
    const pageRows = heads.slice(
      currentPage * rowsPerPage,
      (currentPage + 1) * rowsPerPage,
    );
    const th = "!py-1 !px-2.5 !bg-[#313C4C] !text-[11px] !font-semibold !uppercase !tracking-wide !text-white !border-b !border-[#313C4C]";
    const td = "!py-1 !px-2.5 !text-xs !align-middle !border-b !border-gray-200";

    const radioDot = (checked) => (
      <span
        className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${checked ? "border-[#313C4C]" : "border-gray-400"}`}
      >
        {checked && <span className="w-2 h-2 rounded-full bg-[#313C4C]" />}
      </span>
    );
    const statusBadge = (active) => (
      <span
        className={`inline-flex items-center gap-1 px-1.5 py-[1px] text-[11px] font-medium border ${active
          ? "text-emerald-700 bg-emerald-50 border-emerald-200"
          : "text-gray-500 bg-gray-50 border-gray-200"
          }`}
      >
        <span className={`w-1.5 h-1.5 rounded-full ${active ? "bg-emerald-500" : "bg-gray-400"}`} />
        {active ? "Active" : "Inactive"}
      </span>
    );
    const selectRowProps = (u) => ({
      hover: true,
      tabIndex: 0,
      role: "radio",
      "aria-checked": isSelected(u._id),
      onClick: () => handleSelectUser(u._id, u.firstName),
      onKeyDown: (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleSelectUser(u._id, u.firstName);
        }
      },
      className: `cursor-pointer transition-colors outline-none hover:!bg-slate-50 focus-visible:!bg-slate-100 ${isSelected(u._id) ? "!bg-[#EAF2FC] hover:!bg-[#EAF2FC]" : ""}`,
    });

    return (
      <div className="border border-gray-300 bg-white">
        <div className="flex items-center gap-3 px-3 py-1.5 border-b border-gray-200 bg-[#F8FAFC]">
          <input
            type="search"
            value={selectionSearch}
            onChange={(e) => {
              setSelectionSearch(e.target.value);
              setPage(0);
            }}
            placeholder="Search by name or email..."
            aria-label="Search users"
            className="min-w-0 flex-1 h-7 px-2.5 text-xs border border-gray-300 bg-white outline-none focus:border-[#313C4C]"
          />
          <span className="shrink-0 text-xs text-gray-600">
            {selectedUsers.length ? "1 selected" : "Select one user"}
          </span>
        </div>

        <div className="overflow-x-auto">
          <Table size="small" className="w-full" style={{ tableLayout: "fixed", minWidth: 760 }} aria-label="Users">
            <TableHead>
              <TableRow>
                <TableCell style={{ width: 40 }} className={th} aria-label="Select user" />
                <TableCell style={{ width: 40 }} className={th}>No.</TableCell>
                <TableCell style={{ width: "20%" }} className={th}>Name</TableCell>
                <TableCell className={th}>Email</TableCell>
                <TableCell style={{ width: 90 }} className={th}>Role</TableCell>
                <TableCell style={{ width: 90 }} className={th}>Status</TableCell>
                <TableCell style={{ width: 130 }} className={th}>Team Members</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isInitialLoading && (!userOrganizaton || !userOrganizaton.length) ? (
                <TableRow>
                  <TableCell colSpan={7} align="center" className="!py-10">
                    <div className="flex flex-col items-center gap-2">
                      <CircularProgress size={28} />
                      <span className="text-xs text-gray-500">Loading team leaders...</span>
                    </div>
                  </TableCell>
                </TableRow>
              ) : pageRows.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center" className="!py-10">
                    <div className="flex flex-col items-center gap-1">
                      <PersonOutline className="text-gray-300" fontSize="large" />
                      <span className="text-xs text-gray-500">
                        {term ? "No users match your search" : "No users with role head or superboss found"}
                      </span>
                    </div>
                  </TableCell>
                </TableRow>
              ) : (
                pageRows.map((user, index) => {
                  const members = (user.team_members || []).filter(
                    (m) => matches(user) || matches(m),
                  );
                  const memberCount = user.team_members?.length || 0;
                  const isRowExpanded =
                    !!expandedRows[user._id] || (!!term && !matches(user) && members.length > 0);
                  return (
                    <React.Fragment key={user._id}>
                      <TableRow {...selectRowProps(user)}>
                        <TableCell className={td}>{radioDot(isSelected(user._id))}</TableCell>
                        <TableCell className={`${td} !text-gray-500`}>
                          {currentPage * rowsPerPage + index + 1}
                        </TableCell>
                        <TableCell className={`${td} !font-semibold !text-gray-800 truncate`} title={`${user.firstName} ${user.lastName || ""}`}>
                          {user.firstName} {user.lastName}
                        </TableCell>
                        <TableCell className={`${td} !text-gray-600 truncate`} title={user.email}>
                          {user.email}
                        </TableCell>
                        <TableCell className={`${td} !text-gray-700 capitalize`}>{user.role}</TableCell>
                        <TableCell className={td}>{statusBadge(user.isActivated)}</TableCell>
                        <TableCell className={td}>
                          <button
                            type="button"
                            disabled={!memberCount}
                            aria-expanded={isRowExpanded}
                            onClick={(e) => {
                              e.stopPropagation();
                              toggleRowExpand(user._id);
                            }}
                            className="flex items-center justify-between w-full text-xs text-gray-600 hover:text-[#313C4C] disabled:text-gray-300 disabled:cursor-default"
                          >
                            <span className="flex items-center gap-1">
                              <PeopleOutline style={{ fontSize: 15 }} />
                              {memberCount} {memberCount === 1 ? "member" : "members"}
                            </span>
                            {memberCount > 0 &&
                              (isRowExpanded ? (
                                <KeyboardArrowUp style={{ fontSize: 18 }} />
                              ) : (
                                <KeyboardArrowDown style={{ fontSize: 18 }} />
                              ))}
                          </button>
                        </TableCell>
                      </TableRow>

                      {memberCount > 0 && isRowExpanded && members.map((member) => (
                        <TableRow key={member._id} {...selectRowProps(member)}>
                          <TableCell className={td}>{radioDot(isSelected(member._id))}</TableCell>
                          <TableCell className={`${td} !text-gray-400`}>—</TableCell>
                          <TableCell className={`${td} !text-gray-800 truncate`} title={member.firstName}>
                            <span className="text-gray-400 mr-1">↳</span>
                            {member.firstName} {member.lastName}
                          </TableCell>
                          <TableCell className={`${td} !text-gray-600 truncate`} title={member.email}>
                            {member.email}
                          </TableCell>
                          <TableCell className={`${td} !text-gray-700 capitalize`}>{member.role}</TableCell>
                          <TableCell className={td}>{statusBadge(member.isActivated)}</TableCell>
                          <TableCell className={td} />
                        </TableRow>
                      ))}
                    </React.Fragment>
                  );
                })
              )}
            </TableBody>
          </Table>
        </div>

        <div className="flex items-center justify-between px-3 py-1 border-t border-gray-200 bg-[#F8FAFC]">
          <span className="text-[11px] text-gray-600">
            {heads.length
              ? `Showing ${currentPage * rowsPerPage + 1}-${Math.min((currentPage + 1) * rowsPerPage, heads.length)} of ${heads.length}`
              : "0 results"}
          </span>
          {pageCount > 1 && (
            <div className="flex items-center gap-1">
              <IconButton size="small" aria-label="Previous page" disabled={currentPage === 0} onClick={() => handleChangePage(currentPage - 1)}>
                <ChevronLeft style={{ fontSize: 18 }} />
              </IconButton>
              {Array.from({ length: pageCount }).map((_, p) => (
                <button
                  key={p}
                  type="button"
                  onClick={() => handleChangePage(p)}
                  aria-current={p === currentPage ? "page" : undefined}
                  className={`min-w-[24px] h-6 text-xs font-medium ${p === currentPage ? "bg-[#313C4C] text-white" : "text-gray-600 hover:bg-gray-200"}`}
                >
                  {p + 1}
                </button>
              ))}
              <IconButton size="small" aria-label="Next page" disabled={currentPage >= pageCount - 1} onClick={() => handleChangePage(currentPage + 1)}>
                <ChevronRight style={{ fontSize: 18 }} />
              </IconButton>
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="w-full">
      <div className="flex items-center mb-2 justify-between">
        <h2 className="typo-22-600 font-family text-indigo">
          Organisation Hierarchy
        </h2>
        {isSuperBoss && (
          <div className="flex items-center gap-2">
            {getObject("auth")?.request && (
              <Tooltip title={<span className="text-sm">View Requested Users info</span>}>
                <IconButton
                  color="primary"
                  onClick={() => {
                    const localRequestData = getObject("auth")?.request;
                    if (localRequestData) {
                      setRequestDataFromLocal(localRequestData);
                      setIsRequestInfoModalOpen(true);
                    }
                  }}
                  className="bg-sky-50 shadow-sm border border-sky-100"
                  size="small"
                >
                  <InfoOutlined fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            <Button
              variant="contained"
              color="primary"
              size="small"
              style={{
                height: "28px",
                fontSize: "11px",
                padding: "0 10px",
                fontWeight: 600,
                textTransform: "uppercase",
              }}
              onClick={() => {
                setInitialEditData(null);
                setModalOpen(true);
              }}
            >
              Request for user create
            </Button>
          </div>
        )}
      </div>
      {loader ? (
        <div className="flex justify-center items-center h-40">
          <CircularProgress />
        </div>
      ) : (
        <div
          className="bg-[#e6f7ff] border border-gray-200 rounded-2xl overflow-hidden"
          style={{ height: "84vh" }}
        >
          <ReactFlow
            nodes={nodes}
            edges={edges}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            fitView={false}
            fitViewOnInit={false}
            onInit={onInit}
            defaultViewport={{
              x: window.innerWidth / 2.5,
              y: window.innerHeight / 8.5,
              zoom: 0.5,
            }}
          >
            <Controls />
            <Background gap={20} color="#313C4C" />
          </ReactFlow>
        </div>
      )}
      <CustomAddModal
        open={isUserCreateModalOpen}
        saveLabel="Add"
        title="Add User"
        handleClose={() => setIsUserCreateModalOpen(false)}
        onSubmitConfirm={() => onSubmitConfirm()}
      >
        <AddNewUserFromNodes
          user={newUser}
          allAccess={allAccess}
          setUser={setNewUser}
          parentUser={parentUser}
          isSuperAdminLogin={isSuperAdminLogin}
        />
      </CustomAddModal>
      <AddUserForm
        open={isModalOpen}
        handleClose={() => setModalOpen(false)}
        existingHeads={userOrganizaton.filter(
          (user) => user.role === "head" || user.role === "superboss",
        )}
        initialEditData={initialEditData}
      />

      <CustomShowModal
        open={isRequestInfoModalOpen}
        handleClose={() => setIsRequestInfoModalOpen(false)}
        title="Requested Users Information"
        maxWidth="md"
        fullWidth
      >
        <div className="p-1 bg-gray-50 rounded-md">
          {/* Improved check: specifically checks if the users array has items */}
          {requestDataFromLocal?.users?.length > 0 ? (
            <div className="space-y-5">

              {/* --- Header Section --- */}
              <div className="flex justify-between items-center">
                <Typography variant="subtitle1" className="font-semibold text-gray-800 flex items-center gap-2">
                  Total Requested Users
                  <span className="bg-[#313C4C] text-white px-2.5 py-0.5 rounded-full text-xs font-bold">
                    {requestDataFromLocal.users.length}
                  </span>
                </Typography>

                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  disableElevation
                  startIcon={<EditOutlined className="text-white" />}
                  onClick={() => {
                    setIsRequestInfoModalOpen(false);
                    setInitialEditData(requestDataFromLocal);
                    setModalOpen(true);
                  }}
                >
                  Edit Request
                </Button>
              </div>

              {/* --- Reason Banner --- */}
              {requestDataFromLocal.reason && (
                <div className="bg-blue-50/50 p-3 rounded-md border border-blue-100 text-sm text-blue-900 flex flex-col gap-1">
                  <span className="font-bold text-xs uppercase tracking-wider text-blue-700">Reason for Request</span>
                  <span className="text-gray-700">{requestDataFromLocal.reason}</span>
                </div>
              )}

              {/* --- Table Section --- */}
              <div className="border border-gray-200 rounded-lg shadow-sm overflow-hidden bg-white">
                <div className="overflow-auto max-h-[50vh]">
                  <Table stickyHeader className="min-w-full">
                    <TableHead>
                      <TableRow>
                        {['Name', 'Email', 'Role', 'Modules'].map((header) => (
                          <TableCell
                            key={header}
                            className="bg-[#313C4C] text-white text-xs py-3 font-semibold border-r border-white/10 last:border-0"
                          >
                            {header}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {requestDataFromLocal.users.map((u, i) => (
                        <TableRow key={i} hover className="transition-colors hover:bg-gray-50">
                          <TableCell className="text-sm py-3 text-gray-800 font-medium whitespace-nowrap">
                            {u.firstName} {u.lastName}
                          </TableCell>

                          <TableCell className="text-sm py-3 text-gray-600">
                            {u.email}
                          </TableCell>

                          <TableCell className="py-3">
                            <Chip
                              label={u.role}
                              size="small"
                              className="capitalize bg-blue-100 text-blue-800 font-medium text-xs"
                            />
                          </TableCell>

                          <TableCell className="py-3">
                            {u.moduleAccess?.length > 0 ? (
                              <div className="flex flex-wrap gap-1.5">
                                {u.moduleAccess.map(mod => (
                                  <Chip
                                    key={mod}
                                    label={mod}
                                    size="small"
                                    variant="outlined"
                                    className="text-[11px] text-gray-600 border-gray-300"
                                  />
                                ))}
                              </div>
                            ) : (
                              <span className="text-gray-400 italic text-sm">No modules assigned</span>
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              </div>
            </div>
          ) : (
            <div className="py-12 flex flex-col items-center justify-center text-center bg-white rounded-lg border border-gray-200 shadow-sm">
              <div className="bg-gray-50 p-4 rounded-full mb-3">
                {/* If you don't have PeopleAltOutlined imported, you can use any other standard icon */}
                <Typography variant="h4" className="text-gray-300">📁</Typography>
              </div>
              <Typography variant="h6" className="text-gray-800 font-medium mb-1">
                No Requests Found
              </Typography>
              <Typography variant="body2" className="text-gray-500 max-w-sm">
                There are currently no users associated with this request.
              </Typography>
            </div>
          )}
        </div>
      </CustomShowModal>
    </div>
  );
};

export default UserList;
